import { Box, Typography } from '@mui/material';
import TextareaAutosize from '@mui/material/TextareaAutosize';
import theme from 'src/style-system/theme';

const TextArea = (props: any) => {
  const { name, value, onChange, placeholder, width, height, label } = props;

  return (
    <Box mb="25px">
      {label ? (
        <Typography variant="body2" align="left" color="cumin.main" mb={1}>
          {label}
        </Typography>
      ) : null}
      <TextareaAutosize
        aria-label="text-area"
        name={name}
        value={value}
        onChange={onChange}
        maxRows={9}
        maxLength={250}
        placeholder={placeholder}
        style={{
          width: '100%',
          height: height,
          padding: '15px',
          border: `1px solid ${theme.palette.offWhite.main}`,
          backgroundColor: 'white',
          borderRadius: '25px',
          outline: 'none',
          fontSize: '16px',
          color: !value ? '#a6a6a6' : theme.palette.cumin.main,
          resize: 'none',
        }}
      />
    </Box>
  );
};

export default TextArea;
